// based on rc-collapse 1.11.8
import CollapsePanel from './src/Panel';
import Collapse from './src/Collapse';
import { collapseProps, panelProps } from './src/commonProps';

Collapse.Panel = CollapsePanel;

export { collapseProps, panelProps };
export default Collapse;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.2@ant-design-vue/es/vc-collapse/index.js
// module id = null
// module chunks = 